import React, { useRef, useMemo } from 'react';
import { useFrame } from '@react-three/fiber';

/**
 * Cheap point-cloud rain effect. Each raindrop is a single point in a
 * float32 buffer that falls from y=100 back to y=0 every frame.
 */
export function RainEffect({ intensity = 500 }) {
  const rainRef = useRef();

  const positions = useMemo(() => {
    const pos = new Float32Array(intensity * 3);
    for (let i = 0; i < intensity; i++) {
      pos[i * 3] = (Math.random() - 0.5) * 400;
      pos[i * 3 + 1] = Math.random() * 100;
      pos[i * 3 + 2] = (Math.random() - 0.5) * 400;
    }
    return pos;
  }, [intensity]);

  useFrame((_, delta) => {
    if (!rainRef.current) return;
    const arr = rainRef.current.geometry.attributes.position.array;
    for (let i = 0; i < intensity; i++) {
      arr[i * 3 + 1] -= 60 * delta;
      if (arr[i * 3 + 1] < 0) arr[i * 3 + 1] = 100;
    }
    rainRef.current.geometry.attributes.position.needsUpdate = true;
  });

  return (
    <points ref={rainRef}>
      <bufferGeometry>
        <bufferAttribute attach="attributes-position" count={intensity} array={positions} itemSize={3} />
      </bufferGeometry>
      <pointsMaterial color="#a8c8ff" size={0.3} transparent opacity={0.7} sizeAttenuation />
    </points>
  );
}
